import i18next from "i18next";

export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return String(Math.floor(Math.random() * (max - min)) + min) //Il max è escluso e il min è incluso
}

export function getDate(date, t) {
    let d = new Date(date);
    // let now = new Date();
    let delta = Math.abs(Date.now() - d);
    let days = Math.floor((((delta / 1000) / 60) / 60) / 24)
    if (days === 0) {
        return t("W_TODAY")
    }
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return d.toLocaleDateString(i18next.language,options)
    ///return `${days} ${days === 1 ? t("W_DAY_AGO") : t("W_DAYS_AGO")}`;
    // return new Date(date).toLocaleDateString()
}

export function getIntegrationIcon(name) {
    return 'https://recensioni-io-static-folder.s3.eu-central-1.amazonaws.com/public_climbo/images/integrations/' + name.toLowerCase() +".png"
}

export function toFixedDecimal(num) {
    return  Math.round((num + Number.EPSILON) * 100) / 100
}

export function is_truthy(string) {
    switch (string) {
        case false:
            return false;
        case true:
            return true;
        case null:
            return false;
        case undefined:
            return false;
        default:
            switch (string.toLowerCase().trim()) {
                case "0":
                case "false":
                case "no":
                case "n":
                case "off":
                case null:
                    return false;
                case "1":
                case "true":
                case "yes":
                case "y":
                case "on":
                    return true;
                default:
                    return Boolean(string);
            }
    }
}

export function isWhite(value) {
    switch (value.trim()) {
        case 'white':
        case '#ffffff':
            return true
        default:
            return false
    }
}